<template>
  <section class="bg-message-image">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 relative font-message ">
      <div class="relative">
        <!-- Section header -->
        <div class="max-w-xl mx-auto text-center pt-16 pb-12 md:pb-16">
          <p class="h4 font-normal text-theme-900 mt-12" data-aos="fade-up">
            デトックス（Detox）をご存知でしょうか？<br />
            DetoxのDeには「除去・分解させる」、Toxの由来のToxinには「毒素」という意味があります。つまり、Detoxとは、体に溜まった毒素を体外へ排出することです。<br />
          </p>
          <p class="h4 font-normal text-theme-900 mt-12" data-aos="fade-up">
            身体の美と健康は、外側2割、内側8割の割合で影響しています。
            したがって、内側のケアをして行くことで圧倒的な美と健康を手に入れることができます。
          </p>
          <p class="h4 font-normal text-theme-900 mt-12" data-aos="fade-up">
            現代では生きているだけで体内に毒素が蓄積されていきます。
            私たちも生活しているとゴミやホコリが溜まりますが、定期的にゴミ捨てや掃除をしているからこそお部屋が綺麗に保たれると思います。<br />
            体にも同じことが言えます。体内に溜まった毒素を出すことで体内が綺麗に保たれ、健康になり、そして健康でい続けることができるのです。<br />
            ぜひ、根本的な、本質的な美と健康を手に入れて下さい。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "DescriptionDetox",
  components: {},
  data: function() {
    return {}
  },
}
</script>

<style lang="scss">
.bg-message-image {
  background-image: url("./../images/message-background.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  .font-message {
    .h4 {
      line-height: 1.6;
      font-size: 1.2rem;
      font-weight: 600;
    }
  }
}
</style>
